import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { readCell, readColumnLabel, readColumns, rows, text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<th scope="col"><span class="slex-table-column-label"><!> <span> </span></span></th>`);
var root_1 = $.from_html(`<thead><tr></tr></thead>`);
var root_2 = $.from_html(`<td> </td>`);
var root_3 = $.from_html(`<tr><!></tr>`);
var root_4 = $.from_html(`<div class="slex-table-wrap"><table class="slex-table"><!><tbody></tbody></table></div>`);

export default function Table($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var div = root_4();
	var table = $.child(div);
	var node = $.child(table);

	{
		var consequent_1 = ($$anchor) => {
			var thead = root_1();
			var tr = $.child(thead);

			$.each(tr, 21, () => rows($.get(p).columns), $.index, ($$anchor, column, index) => {
				var th = root();
				var span = $.child(th);
				var node_1 = $.child(span);

				{
					var consequent = ($$anchor) => {
						InlineIcon($$anchor, {
							get name() {
								return $.get(column).icon;
							},
							className: 'slex-table-column-icon'
						});
					};

					$.if(node_1, ($$render) => {
						if ($.get(column) && typeof $.get(column) === "object" && "icon" in $.get(column)) $$render(consequent);
					});
				}

				var span_1 = $.sibling(node_1, 2);
				var text_1 = $.child(span_1, true);

				$.reset(span_1);
				$.reset(span);
				$.reset(th);

				$.template_effect(($0) => $.set_text(text_1, $0), [
					() => readColumnLabel($.get(column), readColumns($.get(p).columns)[index] ?? "")
				]);

				$.append($$anchor, th);
			});

			$.reset(tr);
			$.reset(thead);
			$.append($$anchor, thead);
		};

		var d = $.derived(() => readColumns($.get(p).columns).length);

		$.if(node, ($$render) => {
			if ($.get(d)) $$render(consequent_1);
		});
	}

	var tbody = $.sibling(node);

	$.each(tbody, 21, () => rows($.get(p).rows ?? $.get(p).items), $.index, ($$anchor, row) => {
		var tr_1 = root_3();
		var node_2 = $.child(tr_1);

		{
			var consequent_2 = ($$anchor) => {
				var fragment_1 = $.comment();
				var node_3 = $.first_child(fragment_1);

				$.each(node_3, 17, () => readColumns($.get(p).columns), $.index, ($$anchor, column, index) => {
					var td = root_2();
					var text_2 = $.child(td, true);

					$.reset(td);
					$.template_effect(($0) => $.set_text(text_2, $0), [() => readCell($.get(row), $.get(column), index)]);
					$.append($$anchor, td);
				});

				$.append($$anchor, fragment_1);
			};

			var d_1 = $.derived(() => readColumns($.get(p).columns).length);

			var consequent_3 = ($$anchor) => {
				var fragment_2 = $.comment();
				var node_4 = $.first_child(fragment_2);

				$.each(node_4, 17, () => $.get(row), $.index, ($$anchor, cell) => {
					var td_1 = root_2();
					var text_3 = $.child(td_1, true);

					$.reset(td_1);
					$.template_effect(($0) => $.set_text(text_3, $0), [() => text($.get(cell))]);
					$.append($$anchor, td_1);
				});

				$.append($$anchor, fragment_2);
			};

			var d_2 = $.derived(() => Array.isArray($.get(row)));

			var alternate = ($$anchor) => {
				var td_2 = root_2();
				var text_4 = $.child(td_2, true);

				$.reset(td_2);
				$.template_effect(($0) => $.set_text(text_4, $0), [() => text($.get(row))]);
				$.append($$anchor, td_2);
			};

			$.if(node_2, ($$render) => {
				if ($.get(d_1)) $$render(consequent_2); else if ($.get(d_2)) $$render(consequent_3, 1); else $$render(alternate, -1);
			});
		}

		$.reset(tr_1);
		$.append($$anchor, tr_1);
	});

	$.reset(tbody);
	$.reset(table);
	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}